import React, { useEffect, useState } from "react";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { read } from "Helpers/LocalStorage";
import {
  getAllTypeColor,
  getSelectColor,
  getType,
  InsertProductProfile,
} from "Stores/actions";
import showNotify from "Helpers/Notify";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { Alert } from "@material-ui/lab";
import MuiButton from "Components/MuiButton/MuiButton";
import {DialogActions} from "@material-ui/core";
import {ReactSVG} from "react-svg";
import infoIcon from "Assets/svg/icon/info.svg";
import { useTranslation } from 'react-i18next';
import * as Icons from 'react-bootstrap-icons';

function AddTypeColor({reGetOnBack}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { selectedDasteProfile, types, colors } = useSelector((state) => ({
    selectedDasteProfile: state.profile.selectedDasteProfile,
    types: state.profile.types,
    colors: state.profile.colors,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    typesList: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    colorList: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });

  useEffect(() => {
    if (types) {
      setControls({ typesList: { value: types[0] } });
      setControls({ typesList: { selectItems: types } });
    }
  }, [types]);

  useEffect(() => {
    if (colors) {
      setControls({ colorList: { value: colors[0] } });
      setControls({ colorList: { selectItems: colors } });
    }
  }, [colors]);

  const handleDialog = () => setOpenDialog(!openDialog);

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "typesList") {
      try {
        const params = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
          IdTypeColor: value.value,
        };
        await dispatch(getSelectColor(params));
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { colorList, typesList } = controls;
    try {
      const data = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdGroupProfile: selectedDasteProfile.Id,
        IdColor: colorList.value.Id,
        IdTypeColor: typesList.value.Id,
      };
      await dispatch(InsertProductProfile(data));
      await reGetOnBack(true)
      handleDialog();
    } catch (e) {
      showNotify({
        text: t('correctFormDataRequired'),
        customClass: "error",
      });
    }
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const data = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdStruct: selectedDasteProfile.Struct,
      };
      const res = await dispatch(getType(data));
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdTypeColor: res,
      };
      await dispatch(getSelectColor(params));

      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <MuiIconButton
        title={<Translator id={"ezafeKardan"}/>}
        icon={<Icons.FileEarmarkPlus size={17}/>}
        onClick={handleDialog}
        className="fix-size"
        disabled={selectedDasteProfile?.Disable}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"newProfileTypeColor"}/>}</p>
          </div>
          <DialogContent style={{ overflow: "visible" }}>
            {!loading ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Alert
                      severity="info"
                      variant="outlined"
                      icon={<ReactSVG src={infoIcon} />}>
                      {`${t('ProfileCatName')} : ${selectedDasteProfile?.Name}`}
                  </Alert>
                </Grid>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid item sm={6} xs={12} key={key + index}>
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          autoSelect={true}
                          loading={loading}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <MuiSkeleton xs={6} number={2} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default AddTypeColor;
